export const campaignStatusArr = [
    {
        key: "",
        title:"All"
    },
    {
        key:"drafted",
        title:"Drafted"
    },
    {
        key:"scheduled",
        title:"Scheduled"
    },
    {
        key: "in-process",
        title:"In-Process"
    },
    {
        key:"completed",
        title:"Completed"
    },
    {
        key: "failed",
        title:"Failed"
    },
    {
        key: "cancel",
        title:"Cancelled"
    },

]